import basePageFields from '@fragments/pages/basePageFields';

import TagFragment from '@fragments/pages/TagFragment';
import FileFragment from '@fragments/shared/FileFragment';
import SeoFragment from '@fragments/shared/SeoFragment';
import StreamContainedFragment from '@fragments/shared/StreamContainedFragment';
import SyndicationsFragment from '@fragments/shared/SyndicationsFragment';
import CenterSummaryFragment from '@fragments/summaries/CenterSummaryFragment';
import ImageSummaryFragment from '@fragments/summaries/ImageSummaryFragment';
import PersonSummaryFragment from '@fragments/summaries/PersonSummaryFragment';

export default gql`
    fragment PostFragment on Post {
        ${basePageFields}
        subtype
        eyebrow
        parent {
            value {
                ...CenterSummaryFragment
            }
        }
        relatedContent
        contributors {
            ...PersonSummaryFragment
        }
        supplementalLinks {
            link {
                url
                label
                type
                newTab
                reference {
                    path
                }
                file {
                    ...FileFragment
                }
            }
        }
        tags {
            ...TagFragment
        }
        publisherName
        dek
        hero {
            image {
                ...ImageSummaryFragment
            }
        }
        policyRecommendations
        syndications {
            ...SyndicationsFragment
        }
        streamContained {
            ...StreamContainedFragment
        }
        pdfResources {
            ...FileFragment
        }
        seo {
            ...SeoFragment
        }
    }
    ${ImageSummaryFragment}
    ${PersonSummaryFragment}
    ${CenterSummaryFragment}
    ${TagFragment}
    ${FileFragment}
    ${SeoFragment}
    ${StreamContainedFragment}
    ${SyndicationsFragment}
`;
